import { useState, useEffect, useContext, FormEvent } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { listarSuporteOrganizacoes } from '../../services/suporte'
import { suporteListaOrganizacoesResposta } from '../../interfaces/suporte'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { descriptografarDado } from '../../helpers'
import { toast } from 'react-toastify'
import { Button, Loader } from '../Styles'
import { listarUsuariosOrganizacao } from '../../services/usuarios'
import { usuariosRespostaPayload } from '../../interfaces/usuarios'
import ModalSuporte from '../ModalSuporte'
import FiltrosDefault from '../FiltrosDefault'
import avatarDefault from '../../assets/img/avatarDefault.png'
import DivSituacao from '../DivSituacao'
import LoagindBarra from '../LoadingBarra'
import LoadingCirculo from '../LoadingCirculo'
import NenhumResultadoEncontrado from '../NenhumResultadoEncontrato'
import Permissoes from '../../middleware/Permissoes'
import maisFiltrosImg from '../../assets/img/maisFiltros.png'
import '../../styles/paginaListaDados.css'
import './suporte.css'

function SuporteGesttor () {

    const { modalEstado, exibirModal, atualizarInformacoes } = useContext(ModalEstadoContext)
    const navigate = useNavigate()
    const location = useLocation()

    const { pathname, search } = location

    const usuarioLogado = localStorage.getItem('usuarioGesttor')
    const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))

    const paramsUrl = new URLSearchParams(search)
    const tipoParam = paramsUrl.get('tipo') || ''

    const [tipo, setTipo] = useState(tipoParam)
    const [responsavelFiltro, setResponsavelFiltro] = useState(usuarioLogado)

    const [suportes, setSuportes] = useState<suporteListaOrganizacoesResposta[]>([])
    const [suporte, setSuporte] = useState<suporteListaOrganizacoesResposta>()
    const [modalSuporte, setModalSuporte] = useState(false)
    const [maisSuporte, setmaisSuporte] = useState(false)
    const [pagina, setPagina] = useState(2)
    const [termo, setTermo] = useState('')
    const [tipos, setTipos] = useState<{nome: string, valor: string}[]>([])
    const [situacao, setSituacao] = useState('')
    const [processando, setProcessando] = useState(false)
    const [nenhumResultado, setNenhumResultado] = useState(false)
    const [solicitanteTermo, setSolicitanteTermo] = useState('');
    const [maisFiltros, setMaisFiltros] = useState<boolean>(false)
    const [responsaveis, setResponsaveis] = useState<usuariosRespostaPayload[]>([])
    const [nomeFantasia, setNomeFantasia] = useState<string>("");

    const permissoesFiltrosAvancados = ['master', 'gesttor_suporte_filtro_avancado']
    const temPermissao = permissoesArray.some((permissao: string) => permissoesFiltrosAvancados.includes(permissao))
    
    const exibirModalDadosSuporte = (suporte: suporteListaOrganizacoesResposta, idSuporte: string) => {
        const chaveId = `id${suporte.tipo.charAt(0).toUpperCase()}${suporte.tipo.substring(1)}`;

        navigate(`${pathname}?tipo=${tipo}&${chaveId}=${idSuporte}`);
        exibirModal()

        return setSuporte(suporte)
    }

    const buscarSuportes = async (e: FormEvent) => {

        e.preventDefault()

        setNenhumResultado(false)
        setProcessando(true)

        const params = {
            tipo,
            termo,
            pagina: 1,
            status: situacao,
            nomeFantasia,
            idResponsavel: responsavelFiltro,
            solicitanteTermo: solicitanteTermo
        }

        try {

            const resposta = await listarSuporteOrganizacoes(params)

            if (resposta.data.length === 0) {
                setSuportes(resposta.data)
                setProcessando(false)
                return setNenhumResultado(true)
            }

            if (resposta.status === 200) {
                setSuportes(resposta.data)

                return setProcessando(false)
            }
            
        } catch {
            setProcessando(false)
            toast.error("Erro ao buscar suportes.")
        } finally {
            setMaisFiltros(false)
        }
    }

    const scrollInfinito = (e: any) => {

        const { scrollTop, clientHeight, scrollHeight } = e.target;

        const posicaoScroll = (scrollTop/(scrollHeight - clientHeight)*100)

        if (posicaoScroll === 100) {

            setPagina(prevtState => prevtState + 1)

            const buscarMaisCadastros = async () => {

                setmaisSuporte(true)

                const params = {
                    tipo,
                    termo,
                    pagina,
                    status: situacao,
                    nomeFantasia,
                    solicitanteTermo,
                    idResponsavel: responsavelFiltro
                }

                try {

                    const resposta = await listarSuporteOrganizacoes(params)

                    if (resposta.status === 200) {
                        setSuportes(prevDate => [...prevDate, ...resposta.data])
                        return setmaisSuporte(false)
                    }
            
                } catch {
                    setmaisSuporte(false)
                    toast.error("Erro ao buscar mais cadastros.")
                }
            }

            buscarMaisCadastros()
        }
    }

    useEffect (() => {
        
        setModalSuporte(modalEstado)

        if(!modalEstado) setSuporte(undefined)

    }, [modalEstado])

    useEffect(() => {
        const buscarTipoQuery = () => {

            if (tipo === "") {
                const permissoesAutorizadas = ['master', 'administrativo', 'gesttor_caixa_entrada']
                const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

                if (!temPermissao) return toast.warn("Você não tem permissão para acessar a caixa de entrada.")

                setTipo("")
                setResponsavelFiltro("")
                return
            }
        
            if (tipo === "suporte") {
                const permissoesAutorizadas = ['master', 'administrativo', 'gesttor_atendimento']
                const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

                if (!temPermissao) return toast.warn("Você não tem permissão para acessar a tela de atendimento da plataforma.")
            }

            if (tipo === "sugestão") {
                const permissoesAutorizadas = ['master', 'administrativo', 'desenvolvedor', 'gesttor_melhoria']
                const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

                if (!temPermissao) return toast.warn("Você não tem permissão para acessar a tela de sugestões da plataforma.")
            }

            if (tipo === "bug") {
                const permissoesAutorizadas = ['master', 'administrativo', 'suporte', 'gesttor_suporte']
                const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

                if (!temPermissao) return toast.warn("Você não tem permissão para acessar a tela de suporte da plataforma.")
            }

            return setTipo(tipo)

        }
        buscarTipoQuery()
        
    }, [search])

    useEffect(() => {

        const atualizarTipos = () => {
    
            const tipos: {[key: string]: {nome: string, valor: string}[]} = {
                "": [
                    { nome: 'Todos', valor: '' },
                    { nome: 'Sem Análise', valor: 'sem análise' },
                    { nome: 'Em Análise', valor: 'em análise' },
                ],
                suporte: [
                    { nome: 'Todos', valor: '' },
                    { nome: 'Sem Análise', valor: 'sem análise' },
                    { nome: 'Em Análise', valor: 'em análise' },
                    { nome: 'Aguardando Retorno do Cliente', valor: 'aguardando retorno do cliente' },
                    { nome: 'Finalizado', valor: 'finalizado'}
                ],
                bug: [
                    { nome: 'Todos', valor: '' },
                    { nome: 'Sem Análise', valor: 'sem análise'},
                    { nome: 'Em Análise', valor: 'em análise' },
                    { nome: 'Aguardando Retorno do Suporte', valor: 'aguardando retorno do suporte' },
                    { nome: 'Aguardando Retorno do Cliente', valor: 'aguardando retorno do cliente' },
                    { nome: 'Concluído', valor: 'concluído' },
                ],
                sugestão: [
                    { nome: 'Todas', valor: '' },
                    { nome: 'Sem Análise', valor: 'sem análise'},
                    { nome: 'Em Análise', valor: 'em análise' },
                    { nome: 'Aceita', valor: 'aceita' },
                    { nome: 'Em Desenvolvimento', valor: 'em desenvolvimento' },
                    { nome: 'Recusada', valor: 'recusada' },
                    { nome: 'Concluída', valor: 'concluído' },
                ],
                conquista: [
                    { nome: 'Todos', valor: '' },
                    { nome: 'Sem Análise', valor: 'sem análise' },
                    { nome: 'Em Análise', valor: 'em análise' },
                    { nome: 'Finalizado', valor: 'finalizado' }
                ]
            }
    
            return setTipos(tipos[tipo])
        }

        atualizarTipos()

    }, [tipo])

    useEffect(() => {

        const buscarSuporte = async () => {

            setNenhumResultado(false)
            setProcessando(true)

            try {

                const params = {
                    tipo,
                    termo: '',
                    pagina: 1,
                    status: '',
                    idOrganizacaoFiltro: '',
                    nomeFantasia: '',
                    idResponsavel: responsavelFiltro,
                    solicitanteTermo: ''
                }

                const resposta = await listarSuporteOrganizacoes(params)

                if (resposta.data.length === 0) {
                    setSuportes(resposta.data)
                    setProcessando(false)
                    return setNenhumResultado(true)
                }

                if (resposta.status === 200) {
                    setProcessando(false)
                    return setSuportes(resposta.data)
                }
                
            } catch {

                setProcessando(false)
                toast.error("Erro ao buscar suportes.")
            }
        }

        buscarSuporte ()

    }, [tipo, atualizarInformacoes])

    useEffect(() => {
        const buscarResponsaveis = async () => {
            try {
                const params = {
                    termo: '',
                    situacao: 'ativo'
                }

                const resposta = await listarUsuariosOrganizacao(params)

                if (resposta.status === 200) {
                    return setResponsaveis(resposta.data)
                }
                
            } catch {
                return toast.error('Falha ao Listar os Responsáveis')
            }
        }
        buscarResponsaveis()
    }, [])

    useEffect(() => {

        const paramsUrl = new URLSearchParams(search)
        const tipoQuery = paramsUrl.get('tipo') || ''

        if (tipoQuery === '') {

            const temPermissao = permissoesArray.some((p: string) => ['master', 'administrativo', 'atendimento', 'gesttor_caixa_entrada'].includes(p))
            
            if (!temPermissao) {
                toast.warn("Sem permissão para Caixa de Entrada.");
                return;
            }
            setResponsavelFiltro("");
        } else {
            setResponsavelFiltro(usuarioLogado)
        }
        
        setTipo(tipoQuery)

    }, [search, pathname])

    return (
        <Permissoes permissoes={['master', 'administrativo', 'desenvolvedor', 'suporte', 'gesttor_atendimento', 'gesttor_suporte', 'gesttor_melhoria', 'gesttor_caixa_entrada']}>
            <div id='paginaContainer'>
                {modalSuporte && <ModalSuporte suporte={suporte} />}
                {processando && <LoagindBarra />}
                {nenhumResultado && <NenhumResultadoEncontrado />}
                <FiltrosDefault termo={termo} situacao={situacao} placeholder='Pesquise pelo Título' tipo={undefined} onChangeTermo={(e) => setTermo(e.target.value)} onChangeSituacao={(e) => setSituacao(e.target.value)} onSubmit={buscarSuportes} listaSituacao={tipos} genero={tipo === 'sugestão' ? 'feminino' : 'masculino'} isLoading={processando} maisFiltros={temPermissao ? true : false} acaoMaisFiltro={() => setMaisFiltros(true)} />
                {maisFiltros && temPermissao && <section className='maisOpcoesFiltrosComponente'>
                    <form className='maisOpcoesFiltros' onSubmit={buscarSuportes}>
                        <span className='filtrosContainerTitulo'>
                            <img className='filtrosAvancados' src={maisFiltrosImg} alt='' />
                            <p>Filtros Avançados</p>
                        </span>
                        <section className='opcoesFiltros'>
                            {tipo !== "" && <section>
                                <span>
                                    <label htmlFor="">Responsáveis</label>
                                    <select value={responsavelFiltro || ""} onChange={(e) => setResponsavelFiltro(e.target.value)}>
                                        <option value="">Todos os Responsáveis</option>
                                        {responsaveis.map((responsavel) => (<option value={responsavel.id} key={responsavel.id}>{responsavel.nome}</option>))}
                                    </select>
                                </span>
                                <span>
                                    <label htmlFor="">Situação</label>
                                    <select value={situacao || ""} onChange={(e) => setSituacao(e.target.value)}>
                                        {tipos.map((tipo, index) => (<option value={tipo.valor} key={index}>{tipo.nome}</option>))}
                                    </select>
                                </span>
                            </section>}
                            <section>
                                <span>
                                    <label htmlFor="">Nome do Solicitante</label>
                                    <input
                                        type="text"
                                        placeholder="Buscar por nome do solicitante"
                                        value={solicitanteTermo}
                                        onChange={(e) => setSolicitanteTermo(e.target.value)}
                                    />
                                </span>
                            </section>
                            <section>
                                <span>
                                    <label htmlFor="">Empresas</label>
                                    <input
                                        type="text"
                                        placeholder="Buscar por nome fantasia da empresa"
                                        value={nomeFantasia}
                                        onChange={(e) => setNomeFantasia(e.target.value)}
                                    />
                                </span>
                            </section>
                        </section>
                        <span id="botoesContainerFiltrosTarefas">
                            <Button type='reset' cor='cancelar' isLoading={processando} onClick={() => setMaisFiltros(false)}>Cancelar</Button>
                            <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                                {!processando && 'Buscar Dados'}
                                {processando && <Loader isLoading={processando} />}
                            </Button>
                        </span>
                    </form>
                </section>}
                <section id='fundoContainerPagina' onScroll={scrollInfinito}>
                    <table id='tabelaListaContainer'>
                        <thead>
                            <tr>
                                {tipo === 'sugestão' ? <th id='ladoEsquerdoContent' align='left'>Ranking</th> : ''}
                                <th id={tipo === 'sugestão' ? '' : 'ladoEsquerdoContent'} align='left'>Título</th>
                                <th id='responsavelSuporte' align='left'>Reportador por </th>
                                {tipo !== "" && <th id='responsavelSuporte' align='left'>Responsável </th>}
                                <th align='left'>Empresa</th>
                                <th className='situacaoSuporte' align='center'>Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {suportes.map((suporte) => (
                                <tr key={suporte.id}>
                                    {tipo === 'sugestão' ? <td id='primeiraColuna' onClick={() => exibirModalDadosSuporte(suporte, suporte.id)}>{suporte.participantes.length.toString().padStart(3, '000')}</td> : ''}
                                    <td id={tipo === 'sugestão' ? '' : 'primeiraColuna'} onClick={() => exibirModalDadosSuporte(suporte, suporte.id)}>{suporte.titulo}</td>
                                    <td id='usuarioResponsavelAjudaContent' onClick={() => exibirModalDadosSuporte(suporte, suporte.id)}>
                                        <img id='usuarioResponsavelAjuda' src={suporte.solicitadoPor.avatar ? suporte.solicitadoPor.avatar : avatarDefault} alt='' />
                                        {suporte.solicitadoPor.nome}
                                    </td>

                                    {tipo !== "" && <td onClick={() => exibirModalDadosSuporte(suporte, suporte.id)}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {suporte?.responsavel ? <img id='usuarioResponsavelAjuda' src={suporte.responsavel.avatar ?? avatarDefault} alt='' /> : null}
                                            {suporte?.responsavel?.nome ?? ""}
                                        </div>
                                    </td>}

                                    <td align='left'>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {suporte?.solicitadoPor.organizaco.avatar ? <img id='usuarioResponsavelAjuda' src={suporte.solicitadoPor.organizaco.avatar ?? avatarDefault} alt='' /> : null}
                                            {suporte.solicitadoPor.organizaco.nomeFantasia}
                                        </div>
                                    </td>

                                    <td id={'ladoDireitoContent'} className='situacaoSuporte' align='center' onClick={() => exibirModalDadosSuporte(suporte, suporte.id)}>
                                        <DivSituacao texto={`${suporte.status.charAt(0).toUpperCase()}${suporte.status.substring(1)}`} cor={suporte.status.replace(/\s+/g, '')} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {maisSuporte && <div id='buscarMaisDados'>
                        <LoadingCirculo />
                    </div>}
                </section>
            </div>
        </Permissoes>
    )
}

export default SuporteGesttor